import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {GeneralFormComponent} from '../../general/form/generalForm.component';
import {UserRightGroupUi} from '../../../interfaces/userRightGroupUi';
import {MessageService} from '../../../../shared/message.service';
import {QuestionService} from '../../../services/question.service';
import {GroupService} from '../../../services/group.service';
import {QuestionControlService} from '../../../services/question-control.service';
import {AutomationMappingService} from '../../../services/automation-mapping.service';
import {AutomationMapping} from '../../../interfaces/automationMapping';


@Component({
  selector: 'app-automationmapping-detail',
  templateUrl: '../../general/form/generalForm.component.html',
  styleUrls: ['../../general/form/generalForm.component.css']
})
export class AutomationMappingFormComponent extends GeneralFormComponent<AutomationMapping> implements OnInit {

  public userRightsGroupUis: UserRightGroupUi[];

  constructor(
    route: ActivatedRoute,
    location: Location,
    messagesService: MessageService,
    router: Router,
    questionService: QuestionService,
    userGroupService: GroupService,
    questionControlService: QuestionControlService,
    private automationMappingService: AutomationMappingService
  ) {
    super(route, automationMappingService, location, messagesService, router, questionService, questionControlService,
      {
        entityNameSingular: 'automation mapping',
        entityNamePlural: 'automation mappings',
        formUrl: 'automationmapping',
        listUrl: 'automationmappings',
        generalFormMetaName: 'automation-mapping'
      });
  }
}
